import { useMutation } from '@tanstack/react-query'
import { axiosPatch } from 'Redux/axiosHelper'
import { AdditionalFeePayload } from 'types/event/eventStep3'

// add more fee
const addMoreFee = async ({
  classId,
  payload,
}: {
  classId: string
  payload: AdditionalFeePayload
}) => {
  const response = await axiosPatch(
    payload,
    `v1/edu-class/${classId}/add-more-fee`,
  )
  return response.data
}

export const useAddMoreFee = () => {
  return useMutation(addMoreFee)
}

// edit more fee
const editMoreFee = async ({
  classId,
  feeId,
  payload,
}: {
  classId: string
  feeId: string
  payload: AdditionalFeePayload
}) => {
  const response = await axiosPatch(
    payload,
    `v1/edu-class/${classId}/edit-more-fee/${feeId}`,
  )
  return response.data
}

export const useEditMoreFee = () => {
  return useMutation(editMoreFee)
}

// delete more fee
const deleteMoreFee = async ({
  classId,
  feeId,
}: {
  classId: string
  feeId: string
}) => {
  const response = await axiosPatch(
    {},
    `v1/edu-class/${classId}/delete-more-fee/${feeId}`,
  )
  return response.data
}
export const useDeleteMoreFee = () => {
  return useMutation(deleteMoreFee)
}

//cost and fee for classes
const costAndFeeForClasses = async ({ classId, payload }) => {
  const response = await axiosPatch(payload, `v1/edu-class/${classId}/step5-fee-and-cost`)
  return response.data
}

export const useCostAndFeeForClasses = () => {
  return useMutation(costAndFeeForClasses)
}
